import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/use-auth";

export type MyProfileRow = {
  id: string;
  username: string | null;
  display_name: string | null;
  shop_name: string | null;
  avatar_url: string | null;
  bio: string | null;
  location: string | null;
  seller_profile_enabled: boolean;
  username_changed_at: string | null;
  preferred_locale: string | null;
  created_at: string;
};

const COLS =
  "id,username,display_name,shop_name,avatar_url,bio,location,seller_profile_enabled,username_changed_at,preferred_locale,created_at";

export function useMyProfile(): UseQueryResult<MyProfileRow | null> {
  const { user } = useAuth();
  return useQuery({
    queryKey: ["my-profile", user?.id ?? "anon"],
    enabled: !!user,
    staleTime: 30_000,
    queryFn: async (): Promise<MyProfileRow | null> => {
      if (!user) return null;
      const { data, error } = await supabase
        .from("profiles")
        .select(COLS)
        .eq("id", user.id)
        .maybeSingle();
      if (error) throw error;
      return (data as MyProfileRow | null) ?? null;
    },
  });
}
